export enum SmsStatus {
  QUEUED = 'QUEUED',
  PENDING = 'PENDING',
  SENT = 'SENT',
  FAILED = 'FAILED',
  DELIVERED = 'DELIVERED'
}
